export default "__VITE_ASSET__B7143SF6__"